// extracted by mini-css-extract-plugin
module.exports = {"prevTipClassName":"Pagination_prevTipClassName__jilzD","nextTipClassName":"Pagination_nextTipClassName__tg_Y0","tipInactive":"Pagination_tipInactive__aTL95"};